/**
 * De onderdelen van het beheer: pad en naam. Bewust zonder iconen of andere
 * beheer-code, zodat ook de webshop dit mag gebruiken (bijv. de 404-pagina die
 * iemand die /klanten intikt naar het beheer wijst) zonder het beheer mee te bundelen.
 * Het menu van het beheer (admin/adminNav.ts) bouwt hierop voort.
 */
export const adminSections = {
  overzicht: { path: '', label: 'Overzicht' },
  agenda: { path: '/agenda', label: 'Agenda' },
  mijnDag: { path: '/mijn-dag', label: 'Mijn dag' },
  kassa: { path: '/kassa', label: 'Kassa' },
  inbox: { path: '/inbox', label: 'Inbox' },
  klanten: { path: '/klanten', label: 'Klanten' },
  abonnementen: { path: '/abonnementen', label: 'Abonnementen' },
  cadeaubonnen: { path: '/cadeaubonnen', label: 'Cadeaubonnen & tegoed' },
  bestellingen: { path: '/bestellingen', label: 'Bestellingen' },
  omzet: { path: '/omzet', label: 'Omzet & rapporten' },
  inzicht: { path: '/inzicht', label: 'Marketing-inzicht' },
  producten: { path: '/producten', label: 'Producten' },
  voorraad: { path: '/voorraad', label: 'Voorraad' },
  behandelingen: { path: '/behandelingen', label: 'Behandelingen' },
  protocollen: { path: '/protocollen', label: 'Protocollen' },
  huidvragen: { path: '/huidvragen', label: 'Huidvragen' },
  teksten: { path: '/teksten', label: 'Paginateksten' },
  journal: { path: '/journal', label: 'Journal' },
  social: { path: '/social', label: 'Social planner' },
  ontwerpen: { path: '/ontwerpen', label: 'Ontwerpen' },
  nieuwsbrief: { path: '/mail', label: 'Mail & nieuwsbrief' },
  instellingen: { path: '/instellingen', label: 'Instellingen' },
  beveiliging: { path: '/beveiliging', label: 'Beveiliging' },
  logboek: { path: '/logboek', label: 'Logboek' },
} as const

export type AdminSectionKey = keyof typeof adminSections

/**
 * Onderdelen die alléén in het beheer bestaan. Het beheer heeft ook
 * /producten, /journal en /behandelingen, maar die paden zijn op de webshop
 * iets anders (of bestaan daar zelf), dus die tellen hier niet mee.
 */
export const adminOnlySections: AdminSectionKey[] = [
  'agenda',
  'kassa',
  'inbox',
  'klanten',
  'abonnementen',
  'cadeaubonnen',
  'bestellingen',
  'omzet',
  'inzicht',
  'protocollen',
  'huidvragen',
  'teksten',
  'social',
  'ontwerpen',
  'instellingen',
  'beveiliging',
  'logboek',
]
